@if (date) {
  <p>{{ date | date: NomDateTimeFormats.ADMIN_LONG }}</p>
} @else {
  <p class="sensika-cell--empty">{{ placeholder }}</p>
}
